<template>
  <section
    class="header-section"
    :class="{ smallmode: small, full_view_section: fullView }"
  >
    <div class="header-top-div">
      <!-- <a class="btn" class="chart-btn" href="#chart-section"></a> -->
      <a class="btn share-link" @click="createShareButton()"></a>
      <div id="google_translate_element"></div>
    </div>
    <div class="seller-info-div" :class="{ full_view: fullView }">
      <div class="header-avatar-box">
        <div class="avatar-div">
          <img
            :src="'https://witrino.com/' + themeInfo.info?.admin.img"
            alt=""
          />
        </div>
        <div class="score-star" v-if="themeInfo.info?.admin.score">
          <img
            src="@/assets/img/public/star.svg"
            alt=""
            :class="{ star_activ: sellerInfo.score >= 1 }"
          />
          <img
            src="@/assets/img/public/star.svg"
            alt=""
            :class="{ star_activ: sellerInfo.score >= 2 }"
          />
          <img
            src="@/assets/img/public/star.svg"
            alt=""
            :class="{ star_activ: sellerInfo.score >= 3 }"
          />
          <img
            src="@/assets/img/public/star.svg"
            alt=""
            :class="{ star_activ: sellerInfo.score >= 4 }"
          />
          <img
            src="@/assets/img/public/star.svg"
            alt=""
            :class="{ star_activ: sellerInfo.score >= 5 }"
          />
        </div>
      </div>
      <div class="seller-info">
        <b class="seller-title">{{ themeInfo.info?.business.company_name }}</b>
        <div class="title" v-if="fullView">
          <hr class="title-separator" />
        </div>
        <div class="info-row">
          <p class="info-row-title manager-title">مدیریت:</p>
          <p class="info-row-value">
            {{ themeInfo.info?.admin.name }}
          </p>
        </div>
        <div class="info-row" v-if="fullView">
          <p class="info-row-title address-title">آدرس:</p>
          <div class="info-row-value">
            <!-- <animatedText
              :text="getCity + '-' + themeInfo.info?.business.address"
            /> -->
            <animatedText :text="themeInfo.info?.business.address" />
          </div>
        </div>
        <div class="info-row" v-if="fullView">
          <p class="info-row-title phone-title">تلفن تماس:</p>
          <p v-if="!fullView" class="info-row-value">
            <a
              style="color: inherit; font: inherit"
              :href="'tel:' + themeInfo.info?.business?.phone"
            >
              {{ themeInfo.info?.business?.phone }}
            </a>
          </p>
          <div class="phone-list" v-if="fullView">
            <p
              class="info-row-value"
              v-if="phoneChecker(themeInfo.info?.business?.phone)"
            >
              <a
                style="color: inherit; font: inherit"
                :href="'tel:' + phoneChecker(themeInfo.info?.business?.phone)"
              >
                {{ phoneChecker(themeInfo.info?.business?.phone) }}
              </a>
            </p>
            <p
              class="info-row-value"
              v-if="
                phoneChecker(themeInfo.info?.business.mobile) !=
                  phoneChecker(themeInfo.info?.business.phone) &&
                (phoneChecker(themeInfo.info?.business.phone) ||
                  phoneChecker(themeInfo.info?.business.mobile))
              "
            >
              <a
                style="color: inherit; font: inherit"
                :href="'tel:' + phoneChecker(themeInfo.info?.business?.mobile)"
              >
                {{ phoneChecker(themeInfo.info?.business?.mobile) }}
              </a>
            </p>
            <!-- <p
              class="info-row-value"
              v-for="(item, index) in sellerInfo.phone"
              :key="index"
            >
              {{ item }}
            </p> -->
          </div>
        </div>
        <div
          class="info-row"
          v-if="
            fullView &&
            themeInfo.info?.business.hasOwnProperty('email') &&
            themeInfo.info?.business?.email?.trim() != ''
          "
        >
          <p class="info-row-title email-title">ایمیل:</p>
          <p class="info-row-value">
            {{ themeInfo.info?.business.email }}
          </p>
        </div>

        <!-- <div class="social-networks-div" v-if="fullView">
          <a
            v-if="themeInfo.info?.business.whatsapp"
            :href="themeInfo.info?.business.whatsapp"
            class="whatsapp"
          ></a>
          <a
            v-if="themeInfo.info?.business.telegram"
            :href="themeInfo.info?.business.telegram"
            class="telegram"
          ></a>
          <a
            v-if="themeInfo.info?.business.instagram"
            :href="
              socialLinkCheck(themeInfo.info?.business.instagram, 'instagram')
            "
            class="instagram"
          ></a> -->
        <!-- <a
            v-for="(item, index) in sellerInfo.SocialNetworks"
            :key="index"
            :href="item.link"
            :class="item.name"
          ></a> -->
        <!-- </div> -->
      </div>
    </div>
    <div class="header-bottom-div" @click="fullView = !fullView">
      اطلاعات تماس
      <div class="full-view-btn" :class="{ fullviewbtnUP: fullView }"></div>
    </div>
  </section>
</template>

<script>
import { sellerData } from "@/repo/sellerData.js";
import { publicHelpers } from "@/public/helpers.js";
import { membersData } from "@/repo/membersData.js";
import { mapGetters } from "vuex";
import animatedText from "@/components/animatedText/index.vue";
export default {
  name: "HeaderSection",
  mixins: [sellerData, membersData, publicHelpers],
  components: {
    animatedText,
  },
  props: ["small"],
  data() {
    return {
      fullView: false,
    };
  },
  watch: {
    themeInfo: {
      handler(newValue) {
        console.log(newValue);
      },
      immediate: true,
    },
    baseInfo: {
      handler(newValue) {
        console.log(newValue);
      },
      immediate: true,
    },
  },
  methods: {
    createShareButton() {
      const text = "ویترین من در فالیزنت";
      // const url = "https://wt9.ir/" + this.themeInfo.info?.business.company_name;
      const url = "https://wt9.ir/" + this.themeInfo.info?.business.token;
      const title = "فالیزنت";
      if (navigator.share !== undefined) {
        navigator
          .share({
            title,
            text,
            url,
          })
          .then(() => console.log("Shared!"))
          .catch((err) => {
            console.error(err);
          });
      } else {
        alert("لینک کپی شد.");
        this.copyTextToClipboard(url);
      }
    },
    socialLinkCheck(link, type) {
      if (type == "instagram") {
        link = link.replace("https://", "");
        link = link.replace("www.instagram.com/", "");
        return "https://www.instagram.com/" + link.trim().toLowerCase();
      }
      return "";
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(
        function () {
          console.log("Async: Copying to clipboard was successful!");
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
    fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }

      document.body.removeChild(textArea);
    },
  },

  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
      baseInfo: "base/base",
      managerMode: "managerMode",
    }),
    getCity() {
      if (Object.keys(this.baseInfo).length > 0 && this.themeInfo.info) {
        return this.baseInfo?.city?.find(
          (c) => c.id == this.themeInfo.info?.business.city
        ).name;
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/header/header.css);
</style>